import colors from "../base/colors";
import typography from "../base/typography";
/** Keeps existing status meanings while applying the reference's muted badge treatment. */
export default {
  styleOverrides: {
    root: ({ ownerState }) => {
      const badge = colors.badgeColors[ownerState.color] || colors.badgeColors.secondary;
      return {
        height: 26,
        borderRadius: 6,
        fontSize: typography.size.xxs,
        fontWeight: 600,
        backgroundColor: badge.background,
        color: badge.text,
        "& .MuiChip-icon, & .MuiChip-deleteIcon": { color: "inherit" },
      };
    },
    sizeSmall: { height: 24 },
  },
};
